export default "__VITE_ASSET__CfDp$0RG__"